import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects, Parts} from "components";

import UserRoles from "constants/UserRoles";
import {Button} from "reactstrap";
import {Tooltip} from "@material-ui/core";

const breadcrumbsStatic = [{
	name: 'Hiring',
	url: '/hiring/heatmap',
	icon: 'ticket',
}];

class Candidates extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history,roles,filter,route,prettyName} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: prettyName,
				url: `/hiring/${route}`,
				icon: 'laptop',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}>
					<Button data-id="add-candidate" onClick={this.toggle('modalCandidateAdd')} size="sm" color="primary">
						<i className="fa fa-user"/>&nbsp;&nbsp;Add Candidate
					</Button>
				</Framework.Components.PageBar>

				<Parts.Tickers.HiringTicker/>

				<Collections.Candidates
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
					roles={roles}
					filter={filter}
				/>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Candidate"}
					object={Objects.Candidate}
					history={history}
					toggle={this.state.modalCandidateAdd}
					reportClose={this.reportClose('modalCandidateAdd')}
					afterSave={() => this.setState({refresh: !this.state.refresh})}
					objectProps={{ roles}}
				/>

			</div>
		);
	}
}


export default Framework.Components.withRootState(Candidates)
